export const formatKitchenAnswers = (answers: any) => {
  const data: any = {
    taps: {},
  };

  const kitchenTaps = answers?.kitchen_tap_count;
  const kitchenAppliances = answers?.kitchen_appliances;

  // Format tap groups
  kitchenTaps?.groups
    ?.slice(0, kitchenTaps.count)
    .forEach((group: any, index: number) => {
      data.taps[`tap_${index}`] = {};

      if (group.kitchen_tap_type) {
        data.taps[`tap_${index}`].type = group.kitchen_tap_type;
      }

      if (group.kitchen_tap_flow_rate) {
        data.taps[`tap_${index}`].flowrate = group.kitchen_tap_flow_rate;
      }

      if (group.kitchen_tap_leak) {
        data.taps[`tap_${index}`].leak = group.kitchen_tap_leak;
      }
    });

  // Format kitchen appliance questions
  if (kitchenAppliances?.use_kettle !== undefined) {
    data.kitchen_kettle_boil_water = kitchenAppliances.use_kettle;
  }

  if (kitchenAppliances?.washing_up_method) {
    data.used_for_wash_up = kitchenAppliances.washing_up_method;
  }

  if (kitchenAppliances?.dishwasher_usage_per_week !== undefined) {
    data.dishwasher_per_week = kitchenAppliances.dishwasher_usage_per_week;
  }

  return data;
};
